import axios from "axios/index";

export function registerInterceptor(){
    axios.interceptors.request.use(request => {
        return request;
    })
    
    axios.interceptors.response.use(response =>{        
        return response;
    }, error => {
        if(error.response.status === 401){
            console.log(error);
            window.adobeIMS.signOut();
        }
        return Promise.reject(error);
    })
}

